/* eslint-disable class-methods-use-this */

export default class VideoPlayerBase {
  constructor(el, options = {}) {
    const videoOptions = {
      provider: null,
      ...options,
    };

    if (this.constructor === VideoPlayerBase) {
      throw new Error('Abstract class can\'t be instantiated');
    }
    
    this.el = el;
    this.provider = videoOptions.provider;
    this.player = this.constructor.getPlayer(el);
    this.modal = el.closest('.modal');
  }

  init() {
    // if (this.el.closest('.video-background')) {
    //   this.autoplay();
    // }

    if (this.modal) {
      this.modalHandler();
    }
  }
  
  static getPlayer(iframe) {
    return iframe;
  }

  autoplay() {
    /* eslint-disable class-methods-use-this */
    throw new Error('Method \'autoplay()\' must be implemented.');
  }

  modalHandler() {
    this.modal.addEventListener('hidden.bs.modal', () => {
      this.stop();
    });

    this.modal.addEventListener('shown.bs.modal', () => {
      this.play();
    });
  }

  stop() {
    /* eslint-disable class-methods-use-this */
    throw new Error('Method \'stop()\' must be implemented.');
  }

  play() {
    /* eslint-disable class-methods-use-this */
    throw new Error('Method \'play()\' must be implemented.');
  }
}
